module.exports = __webpack_public_path__ + "static/media/superBrain.e3422644.png";